import React, {memo, useCallback, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";

function toDraftString(value) {
    if (value === null || value === undefined) {
        return '';
    }
    if (Array.isArray(value)) {
        return value.map((entry) => String(entry).trim()).filter(Boolean).join(', ');
    }
    if (typeof value === 'object') {
        return '';
    }
    return String(value);
}

/**
 * Text / number input: local draft; parent patch updates only on blur when the string changed.
 */
const PreventativeCommittedTextField = memo(({
                                                 committedValue,
                                                 textFieldProps,
                                                 onCommit,
                                             }) => {
    const [draft, setDraft] = useState(() => toDraftString(committedValue));

    useEffect(() => {
        setDraft(toDraftString(committedValue));
    }, [committedValue]);

    const handleBlur = useCallback(() => {
        const next = toDraftString(draft);
        const prev = toDraftString(committedValue);
        if (next !== prev) {
            onCommit(next);
        }
    }, [draft, committedValue, onCommit]);

    return (
        <TextField
            {...(textFieldProps || {})}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={handleBlur}
            size="small"
            fullWidth
            variant="outlined"
        />
    );
});

export default PreventativeCommittedTextField;
